import { render, staticRenderFns } from "./CreateCaseModal.vue?vue&type=template&id=275fd922&scoped=true"
import script from "./CreateCaseModal.vue?vue&type=script&lang=js"
export * from "./CreateCaseModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCaseModal.vue?vue&type=style&index=0&id=275fd922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275fd922",
  null
  
)

export default component.exports